export default "__VITE_ASSET__f7f3087c__"